/**
 * Per-tab "Show join tables" right-click context menu wrapper for the
 * FK Breadcrumb chip-row.
 *
 * Slice 5 — wraps the chip-row `<nav>` so right-click anywhere on the row
 * (between chips, on whitespace) surfaces a single "Show join tables" /
 * "Hide join tables" toggle. Right-clicks ON a chip surface the chip's
 * own context menu (Radix nests trigger menus correctly).
 */

import type { ReactNode } from 'react';
import {
  ContextMenu,
  ContextMenuCheckboxItem,
  ContextMenuContent,
  ContextMenuTrigger,
} from '../../../../../components/ui/context-menu';

type FkBreadcrumbContextMenuWrapperProps = {
  readonly children: ReactNode;
  readonly showJoinTables: boolean;
  readonly onToggleShowJoinTables: () => void;
};

export function FkBreadcrumbContextMenuWrapper({
  children,
  showJoinTables,
  onToggleShowJoinTables,
}: FkBreadcrumbContextMenuWrapperProps) {
  return (
    <ContextMenu>
      <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
      <ContextMenuContent data-testid="fk-breadcrumb-row-context-menu">
        <ContextMenuCheckboxItem
          checked={showJoinTables}
          onCheckedChange={onToggleShowJoinTables}
          className="text-xs"
          data-testid="fk-breadcrumb-toggle-show-join-tables"
        >
          Show join tables
        </ContextMenuCheckboxItem>
      </ContextMenuContent>
    </ContextMenu>
  );
}
